import React, { useEffect, useState } from 'react';
import { SimpleView, GridView, Widget, FormSelect, MasterDetailForm } from '@digital/ui';
import { Collapse, Icon } from 'antd';
import { SelectValue } from 'antd/lib/select';

import { CrfContratoEspecial, getAllCrfContratosEspeciais } from '@app/api/crf/contratoEspecial';
import TabelaContratoEspecial from './TabelaContratoEspecial';

const { Panel } = Collapse;

const CrfContratosEspeciais = () => {
  const [contratos, setContratos] = useState<CrfContratoEspecial[]>();
  const [selectedContratoId, setSelectedContratoId] = useState<string>();
  const [selectedContrato, setSelectedContrato] = useState<string>();

  useEffect(() => {
    const getData = async () => {
      const result = await getAllCrfContratosEspeciais();
      if (result) {
        setContratos(result);
        
        var contrato = result.reduce(r => {
          return r;
        });
        
        if (contrato) {
          setSelectedContrato(contrato.mes + '/' + contrato.ano);
          setSelectedContratoId(contrato.mes + '/' + contrato.ano);
        }
      }
    };

    getData();
  }, []);

  const handleChangeContratoEspecial = (contrato: SelectValue) => {
    
    if (contrato !== undefined) {
      //let ce = contratos && contratos.find(c => c.id === contrato);
      //let selectedItemLabel = `${ce.mes.toString().padStart(2, '0')}/${ce.ano}`;
      setSelectedContratoId(contrato.toString());
      //setSelectedContrato(selectedItemLabel);
      setSelectedContrato(contrato.toString());
    }
  };

  return (
    <SimpleView>
      <GridView title="Contratos Especiais" noform>
        <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="2" header="Contratos Especiais" style={{ border: 0 }}>
            <MasterDetailForm>
              <Widget>
                <FormSelect
                  label="Mês/Ano"
                  name="ano"
                  showSearch
                  options={
                    (contratos &&
                      contratos.map(a => ({
                        text: `${a.mes.toString().padStart(2, '0')}/${a.ano}`,
                        value: `${a.mes.toString().padStart(2, '0')}/${a.ano}`,
                      }))) ||
                    []
                  }
                  span={3}
                  onSelect={e => handleChangeContratoEspecial(e)}
                  value={selectedContrato}
                />
              </Widget>
            </MasterDetailForm>
          </Panel>
        </Collapse>
        <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="2" header="Lista de Contratos Especiais" style={{ border: 0 }}>
            <MasterDetailForm>
              <Widget>
                <TabelaContratoEspecial selectedContratoId={selectedContratoId || ''} />
              </Widget>
            </MasterDetailForm>
          </Panel>
        </Collapse>
      </GridView>
    </SimpleView>
  );
};

export default CrfContratosEspeciais;
